import { AlertMessage } from './alert-message';
import { AlertMessageType } from './alert-message-type';

export class ErrorMessage extends AlertMessage {
  constructor(message: string, params?: string[], dismissible?: boolean, translateParams?: boolean) {
    super(message, params, dismissible, AlertMessageType.Error, translateParams);
  }
}
